import { cn } from '@/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import { forwardRef } from 'react'
import { TooltipButton } from './TooltipButton'

const iconBgVariants = cva('flex size-9 shrink-0 items-center justify-center rounded-full border border-transparent', {
  variants: {
    variant: {
      outline: 'border-border bg-background text-foreground',
      success: 'bg-success text-success-foreground',
      warning: 'bg-warning text-warning-foreground',
      error: 'bg-error text-error-foreground',
      info: 'bg-info text-info-foreground',
    },
  },
})

interface IconBgProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof iconBgVariants> {
  tooltip?: string
}

const IconBg = forwardRef<HTMLDivElement, IconBgProps>(({ children, tooltip, className, variant, ...props }, ref) => {
  const background = (
    <div ref={ref} className={cn(iconBgVariants({ variant }), !variant && 'bg-muted', className)} {...props}>
      {children}
    </div>
  )

  return tooltip ? <TooltipButton tooltip={tooltip}>{background}</TooltipButton> : background
})
IconBg.displayName = 'IconBg'

export { IconBg, iconBgVariants }
